module.exports = __webpack_public_path__ + "img/organicjr.ca92945f.jpeg";